/**
 * This class represents a charge type from CFM.
 */
export class ChargeType {

	constructor(Identifier: string, Value: number, Name: string) {
		this.Identifier = Identifier;
		this.Value = Value;
		this.Name = Name;
	}

	/** The string identifier for the charge type. */
	public Identifier: string;

	/** The number identifier for the charge type. */
	public Value: number;

	/** The human readable name of the charge type. */
	public Name: string;

}